'use strict';

(function(z, Backbone, Translator){

    z.PaymentImportModel = Backbone.Model.extend({

        /**
         * Url
         */
        url: '/orders/import/payments',

        /**
         * Model validation
         */
        validation: {
            'paymentTemplate': {
                fn: function(val, attr, computed){

                    if (computed.isTemplateEmpty) {

                        return Translator.trans('js.error_message_importform_template_required');
                    }

                    if (computed.isTemplateInvalidType) {

                        return Translator.trans('js.error_message_importform_template_invalidtype');
                    }

                    if (computed.isTemplateInvalidType) {

                        return Translator.trans('js.error_message_importform_template_invalidsize');
                    }
                }
            }
        }
    });

})(window.z = window.z || {}, Backbone, Translator);